import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { useEffect } from "react";
import { toast } from "../lib/toast";
import { ApiErrorType } from "../types";

export default function useError(
  isError: boolean,
  error: FetchBaseQueryError | SerializedError | undefined,
  message: string
) {
  useEffect(() => {
    if (isError && error) {
      const err = error as ApiErrorType;

      const resolveErrorMessage = () => {
        const data = err.data as any;
        if (typeof data === "string") return data;
        if (data?.error_description && typeof data.error_description === "string")
          return data.error_description;
        if (data?.message && typeof data.message === "string") return data.message;
        if (data?.data?.error_description && typeof data.data.error_description === "string")
          return data.data.error_description;
        if (data?.data?.message && typeof data.data.message === "string")
          return data.data.message;
        return message;
      };

      toast("error", resolveErrorMessage());
    }
  }, [error, isError, message]);

  return undefined;
}
